<shared-modal>
  <!-- header -->
  <h2 slot="header" class="flex">
    Criar categoria

    <span
      class="material-symbols-rounded cursor-pointer ml-auto"
      (click)="sharedService.closeModal(route)"
      >close</span
    >
  </h2>

  <!-- body -->
  <input placeholder="Nome" [(ngModel)]="tagName" />

  <!-- footer -->
  <button slot="footer" (click)="createTag()">Criar</button>
</shared-modal>

<!-- <shared-modal [mobile]="sharedService.screenSize !== 'l'">
  <h2 slot="header">{{ alertService.title }}</h2>
  <p [innerHTML]="alertService.message"></p>
  <button slot="footer" class="secondary" (click)="cancel()">
    {{ alertService.cancelButtonText || 'Cancelar' }}
  </button>
  @if (alertService.confirmButtonText) {
    <button slot="footer" (click)="confirm()">
      {{ alertService.confirmButtonText }}
    </button>
  }
</shared-modal> -->
